const groupBy = (xs, key) => xs.reduce((rv, x) => {
  const _rv = rv;
  (_rv[x[key]] = rv[x[key]] || []).push(x);
  return _rv;
}, {});

export default groupBy;
